<template>
	<div class="up-report list-box">
		<div v-if="pageState === 'list'">
			<Tree @changeSwitch="changeSwitch" :switchVal="isDown" :nodeId="searchParams.areaId" @nodeClick="nodeClick"></Tree>
		</div>
		<div v-if="pageState === 'list'" class="right-box">
			<TableSearch :search-config="searchConfig" :search-params="searchParams" @resetCallBack="reset()" @search="search"></TableSearch>
			<Table :tabelButtons="tabelButtons" :table-config="tableConfig" :pagination="pagination" :template-data="tableData"></Table>
		</div>

		<alarm-detail-im v-if="pageState === 'detail'" :alarm-id="alarmId" @back="backList"></alarm-detail-im>
	</div>
</template>

<script>
	import Tree from '@/components/Tree/nodeTree';
	import {
		listAPI
	} from '@/api-path/command-center.js'
	import AlarmDetailIm from '../alarm-detail-im/alarm-detail-im';
	const alarmTypes = [{
		label: '一键报警',
		value: '1',
	}, {
		label: '图文报警',
		value: '2'
	}, {
		label: '终端报警',
		value: '3'
	}, {
		label: '110报警',
		value: '4'
	}, {
		label: '120报警',
		value: '5'
	}, {
		label: '119报警',
		value: '6'
	}, {
		label: '第三方报警',
		value: '7'
	}]
	export default {
		name: "up-report",
		components: {
			Tree,
			AlarmDetailIm
		},
		data() {
			return {
				pageState: 'list',
				alarmId: '',
				isDown: false, // 是否查询下级
				searchConfig: {
					items: [{
							valueType: 'select',
							placeholder: '请选择报警方式',
							key: 'alarmType',
							data: alarmTypes
						}, {
							placeholder: '关键词搜索',
							key: 'search',
						}, {
							placeholder: '开始时间:结束时间',
							valueType: 'datetimerange',
						}

					]
				},
				searchParams: {
					areaId: '', // 区域ID
					status: '4', // 事件状态
					userId: sessionStorage.getItem('userId'), // 用户Id
					date: [],
					page: 1,
					size: 15,
					alarmType: '',
					search: '',
				},
				tabelButtons: [],
				tableConfig: {
					rows: [{
						label: '报警时间',
						width: '130px',
						prop: 'happenDate',
					}, {
						label: '报警人',
						prop: 'userName',
					}, {
						label: '处理人',
						prop: 'dealName',
					}, {
						label: '区域',
						prop: 'areaName',
					}, {
						label: '接警中心',
						prop: 'centerName',
					}, {
						label: '接警来源',
						prop: 'sourceName',
					}, {
						label: '事件类型',
						prop: '',
					}, {
						label: '报警类型',
						prop: 'alarmType',
					}, {
						label: '报警内容',
						prop: 'content',
						width: '200px',
						type: "popover",
					}, {
						label: '报警地点',
						prop: 'address',
						width: '200px',
						type: "popover",
					}, {
						label: '状态',
						prop: 'statusName',
					}],
					rowButtons: {
						items: [{
							label: '查看',
							fn: (data) => {
								this.$store.commit('setVisionGroupId',data.id)
								this.alarmId=data.id
								this.pageState = 'detail';
							}
						}]
					},
				},
				tableData: [],
				pagination: {
					show: true,
					page: 1,
					size: 15,
					total: 0,
					sizeChange: (size) => {
						this.pagination.size = size
						this.searchParams.size = size
						this.search()
					},
					pageChange: (page) => {
						this.pagination.page = page
						this.searchParams.page = page
						this.search()
					},
				},
			}
		},
		computed: {
			newAlarm() {
				return this.$store.state.hasNewAlarm //新的报警
			},
			visionGroupId(){
				return this.$store.state.visionGroupId
			}
		},
		watch: {
			newAlarm(newVal, oldVal) {
				if (newVal) {
					this.search();
				}
			},
			visionGroupId(newVal,oldVal){
				if(newVal!=''){
					this.pageState='detail'
					this.alarmId=newVal
				}
			}
		},
		created() {
			if(this.$store.state.visionGroupId){
				this.alarmId=this.$store.state.visionGroupId
				this.pageState='detail'
			}
		},
		beforeDestroy() {
			this.$store.commit('setVisionGroupId','');
		},
		methods: {
			search() {
				const {
					date,
					...params
				} = { ...this.searchParams
				}
				params.startTime = date[0]
				params.endTime = date[1]
				params.isDown = this.isDown
				this.$http.get(listAPI.alarmList, {
					params
				}).then(res => {
					res.result.pageList.map(item => {
						item.alarmSource = this.matchFn.matchCodeName('ALARM_SOURCE', item.alarmSource)
						item.alarmType = this.matchFn.matchCodeName('ALARM_TYPE', item.alarmType)
					})
					this.tableData = res.result.pageList
					this.pagination.total = res.result.total
					this.$store.commit('setHasNewAlarm',false)
				})
			},
			backList() {
				this.pageState = 'list'
			},
			changeSwitch(node) {
				this.isDown = node
				this.search()
			},
			nodeClick(node) {
				this.searchParams.areaId = node.id;
				this.searchParams.page = this.pagination.page = 1;
				this.areaId = node.id;
				this.search()
			},
			reset() {
				this.searchParams.page = this.pagination.page = 1;
				this.searchParams.size = this.pagination.size = 15;
				this.searchParams.areaId = this.areaId;
				this.searchParams.userId = sessionStorage.getItem('userId');
				this.searchParams.status = '4';
				this.searchParams.search = '';
				this.searchParams.alarmType = '';
				this.searchParams.date = [];
				this.search();
			},
		}
	}
</script>

<style scoped>

</style>
